<div class="modal-header">
  <h4 class="modal-title" id="modal-title" translate>{{ !!claim?.id ? 'CLAIM' : 'CREATE_CLAIM' }} {{ claim?.id }}</h4>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form class="form" [formGroup]="orkForm" (ngSubmit)="onCreateClaim(saveBtn)">
  <div class="modal-body">
    <fieldset [disabled]="!!claim?.id">
      <div class="row">
        <div class="col-12 col-md-6">
          <lib-meta-select-input
            formControlName="kundreklamationorsak"
            table="orkk"
            metaId="kundreklamationorsak"
            metaDisplay="kundreklamationbeskr"
          ></lib-meta-select-input>
          <lib-forms-message-error [controller]="orkForm.get('kundreklamationorsak')"></lib-forms-message-error>
          <lib-meta-select-input
            formControlName="claimworkflow"
            table="claimworkflow"
            metaId="claimworkflow"
            metaDisplay="claimworkflowdescr"
            [optionsFilterFunction]="filterClaimWork.bind(this)"
          ></lib-meta-select-input>
          <lib-forms-message-error [controller]="orkForm.get('claimworkflow')"></lib-forms-message-error>
          <lib-gung-text-input
            gungTranslate="Q_ARTSERIENR"
            formControlName="q_artserienr"
            placeholder="Q_ARTSERIENR"
          ></lib-gung-text-input>
          <lib-gung-text-input
            gungTranslate="Q_DOTNR"
            formControlName="q_dotnr"
            placeholder="Q_DOTNR"
          ></lib-gung-text-input>
          <!-- <lib-gung-text-input gungTranslate="EDIT" formControlName="edit" placeholder="EDIT"></lib-gung-text-input> -->
          <lib-gung-text-input
            gungTranslate="SALJARE"
            formControlName="saljare"
            placeholder="SALJARE"
          ></lib-gung-text-input>
          <lib-gung-text-input gungTranslate="FTGNR" formControlName="ftgnr" placeholder="FTGNR"></lib-gung-text-input>
        </div>
        <div class="col-12 col-md-6">
          <lib-gung-text-input
            gungTranslate="ORDERNR"
            formControlName="ordernr"
            placeholder="ORDERNR"
          ></lib-gung-text-input>
          <div *ngIf="orkForm.get('ordernr').hasError('notNumeric')" translate>
      NOT_NUMERIC
          </div>
          <lib-gung-text-input
            gungTranslate="FAKTNR"
            formControlName="faktnr"
            placeholder="FAKTNR"
          ></lib-gung-text-input>
          <div *ngIf="orkForm.get('faktnr').hasError('notNumeric')" translate>
            NOT_NUMERIC
          </div>
          <lib-gung-text-input
            gungTranslate="CLAIMQTY"
            formControlName="claimqty"
            placeholder="CLAIMQTY"
          ></lib-gung-text-input>
          <lib-forms-message-error [controller]="orkForm.get('claimqty')"></lib-forms-message-error>
          <lib-gung-text-input gungTranslate="EVENTNOTE" formControlName="eventnote"></lib-gung-text-input>
          <lib-gung-text-input
            gungTranslate="ARTNR"
            formControlName="artnr"
            placeholder="ARTNR"
            *ngIf="!!claim?.id; else searchArticle"
          ></lib-gung-text-input>
          <div class="pt-3 custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="q_fleet" name="q_fleet" formControlName="q_fleet" />
            <label class="custom-control-label" for="q_fleet" translate>Fleet</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="q_bosspl"
              name="q_bosspl"
              formControlName="q_bosspl"
            />
            <label class="custom-control-label" for="q_bosspl" translate>Boss PL</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="q_kompletthjul"
              name="q_kompletthjul"
              formControlName="q_kompletthjul"
            />
            <label class="custom-control-label" for="q_kompletthjul" translate>KOMPLETT_HJUL</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="q_falg"
              name="q_falg"
              formControlName="q_falg"
            />
            <label class="custom-control-label" for="q_falg" translate>FALG</label>
          </div>
        </div>

        <div class="col-12">
          <lib-gung-text-area-input
            gungTranslate="NOTE"
            formControlName="edit"
            placeholder="NOTE"
          ></lib-gung-text-area-input>
          <lib-forms-message-error [controller]="orkForm.get('edit')"></lib-forms-message-error>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss('cancel click')" translate>
      CLOSE
    </button>
    <button [ngClass]="{ 'd-none': claim?.id }" type="submit" class="btn btn-primary btn-sm ml-2" #saveBtn translate>
      CREATE
    </button>
  </div>
</form>

<ng-template #searchArticle>
  <div class="">
    <label for="typeahead-prevent-manual-entry" translate>ARTNR</label>
    <input
      #searchlement
      id="typeahead-prevent-manual-entry"
      type="text"
      class="form-control"
      [(ngModel)]="modelSearch"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="resultFormatter"
      (selectItem)="selectProduct($event)"
      placeholder="{{ 'ARTNR' | translate }}"
      (focusout)="focusout($event, modelSearch)"
      (ngModelChange)="ngModelChange($event, searchlement)"
      [editable]="false"
    />
  </div>
</ng-template>
